export default {
  inventories: [],
  inventory: {},
};
